import {FC, useMemo} from 'react';
import TimeProgressBar from '../../../../common/time_progress_bar/TimeProgressBar';
import useTimer, {getDatesDifferenceInSeconds} from '../../../../../hooks/useTimer';
import {CurrentTask} from '../../../types';
import {SECONDS_IN_MINUTE} from '../../../../../constants/constants';
import {ProcessCode} from '../../../../processes/types';

type CurrentTaskProgressProps =
  Pick<CurrentTask, 'startedAt' | 'targetTime' | 'status' | 'completedAt'> & {
    alertRange: Nullable<number>,
    onChangeProgressBarStateCallback: (state: string) => void,
    isWideProgressBar?: boolean
  }

const CurrentTaskProgress: FC<CurrentTaskProgressProps> = ({
  startedAt, targetTime, status, completedAt,
  alertRange, onChangeProgressBarStateCallback, isWideProgressBar
}) => {
  const isRunningTask = status?.code === ProcessCode.RUNNING;

  const initialDatesDiff = useMemo(() =>
    getDatesDifferenceInSeconds(startedAt, completedAt),
  [startedAt]);

  const goalTime = useMemo(() => {
    return targetTime ? `Goal: ${targetTime / SECONDS_IN_MINUTE}m` : '';
  }, [targetTime]);

  const {resultTimeHHMMSS: resultTime, timeDiffInSeconds} = useTimer({
    initialDiff: initialDatesDiff,
    initialActive: isRunningTask
  });

  return (
    <div className="current-task-progress">
      <div className="current-task-progress__time">
        <p>{resultTime}</p>
        <p>{goalTime}</p>
      </div>

      <div className="current-task-progress__bar">
        <TimeProgressBar
          currentTimeInSeconds={timeDiffInSeconds}
          targetTimeInSeconds={targetTime}
          alertRangeInSeconds={alertRange}
          shouldShowExpiredIcon={false}
          isCurrentlyRunning={isRunningTask}
          hasIntervals={isRunningTask}
          onChangeStateCallback={onChangeProgressBarStateCallback}
          isWide={isWideProgressBar}
        />
      </div>
    </div>
  );
};

export default CurrentTaskProgress;
